import { createStyles, makeStyles } from '@mui/styles';
import { NextTheme } from '../../../layout/theme-next/provider';

export const styles = makeStyles<NextTheme>(() =>
  createStyles({
    tooltip: {
      maxHeight: '500px',
      minHeight: '18px',
      overflow: 'auto',
      fontSize: 12,
      whiteSpace: 'pre-line',
    },
  }),
);
